import { UserTypeSelect } from "@/components/selects";
import { Create, PasswordInput, SimpleForm, TextInput } from "react-admin";

const UserCreate = () => {
  return (
    <Create>
      <SimpleForm>
        <TextInput source="full_name" label="ra.users.fullName" />
        <TextInput source="pseudo" label="ra.users.pseudo" />
        <PasswordInput source="password" label="Password" />
        <TextInput source="email" label="ra.users.mail" />
        <UserTypeSelect source="role" label="ra.users.type" />
      </SimpleForm>
    </Create>
  );
};
export default UserCreate;
